module.exports = __webpack_public_path__ + "img/1.684f3c97.png";